import React from "react";
import {AdjustTaxes} from "../../components/adjust-taxes/AdjustTaxes";

export const AdjustTaxesView: React.FunctionComponent = () => {
  return <AdjustTaxes />;
};
